import React from "react";
import { inject, observer } from "mobx-react";
import { BestDropdown, Checkbox, FormColumn4Wide } from "best-common-react";

function OrgsAdminFilters(props) {
  const { commonStore, orgAdminStore } = props.rootStore;
  return (
    <div className="row">
      <FormColumn4Wide>
        <BestDropdown
          id="year"
          title="Year"
          value={orgAdminStore.getSelectedYear}
          options={commonStore.activeYearsDropdownList}
          onChange={orgAdminStore.setSelectedYear}
        />
      </FormColumn4Wide>
    </div>
  );
}

export default inject("rootStore")(observer(OrgsAdminFilters));
